// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/FightPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AgeDivisionPayload, ageDivisionPayloadFromJSON, ageDivisionPayloadToJSON } from "./enums/AgeDivisionPt";
import {
  AmateurBoxingWeightClassPayload,
  amateurBoxingWeightClassPayloadFromJSON,
  amateurBoxingWeightClassPayloadToJSON,
} from "./enums/AmateurBoxingWeightClassPt";
import {
  ChickenFightWeightClassPayload,
  chickenFightWeightClassPayloadFromJSON,
  chickenFightWeightClassPayloadToJSON,
} from "./enums/ChickenFightWeightClassPt";
import { FightSportPayload, fightSportPayloadFromJSON, fightSportPayloadToJSON } from "./enums/FightSportPt";
import { GenderPayload, genderPayloadFromJSON, genderPayloadToJSON } from "./enums/GenderPt";
import {
  ImmafMmaWeightClassPayload,
  immafMmaWeightClassPayloadFromJSON,
  immafMmaWeightClassPayloadToJSON,
} from "./enums/ImmafMmaWeightClassPt";
import {
  MuayThaiKickboxingNoFaceWeightClassPayload,
  muayThaiKickboxingNoFaceWeightClassPayloadFromJSON,
  muayThaiKickboxingNoFaceWeightClassPayloadToJSON,
} from "./enums/MuayThaiKickboxingNoFaceWeightClassPt";
import {
  MuayThaiKickboxingWeightClassPayload,
  muayThaiKickboxingWeightClassPayloadFromJSON,
  muayThaiKickboxingWeightClassPayloadToJSON,
} from "./enums/MuayThaiKickboxingWeightClassPt";
import {
  NoGiJiuJitsuWeightClassPayload,
  noGiJiuJitsuWeightClassPayloadFromJSON,
  noGiJiuJitsuWeightClassPayloadToJSON,
} from "./enums/NoGiJiuJitsuWeightClassPt";
import {
  ProMmaWeightClassPayload,
  proMmaWeightClassPayloadFromJSON,
  proMmaWeightClassPayloadToJSON,
} from "./enums/ProMmaWeightClassPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * 체급 Payload
 *
 * 체급 코드는 종목마다 다른 enum 이므로 sport 와 oneof 를 짝지어 읽는다.
 * division · gender · name · maxWeightKg 는 서버가 체급 코드에서 채워 내려주는 표시용 값이고,
 * 요청에 실려 오더라도 서버는 sport 와 oneof 만 신뢰한다.
 *
 * division 이 repeated 인 이유: 한 체급이 여러 부에 걸친다.
 * 무에타이 · 킥복싱의 「중 · 고 · 일반부 통합」 체급표는 세 부가 같은 체급을 쓰고,
 * 닭싸움 ABSOLUTE 무체급은 전 부문에 적용된다.
 */
export interface WeightClassPayload {
  /** 격투기 종목 */
  sport: FightSportPayload;
  /** 아마추어복싱 */
  amateurBoxing?:
    | AmateurBoxingWeightClassPayload
    | undefined;
  /** IMMAF 종합격투기 */
  immafMma?:
    | ImmafMmaWeightClassPayload
    | undefined;
  /** 무에타이 · 킥복싱 */
  muayThaiKickboxing?:
    | MuayThaiKickboxingWeightClassPayload
    | undefined;
  /** 프로 MMA */
  proMma?:
    | ProMmaWeightClassPayload
    | undefined;
  /** 닭싸움 */
  chickenFight?:
    | ChickenFightWeightClassPayload
    | undefined;
  /** 무에타이 · 킥복싱(안면타격 X) — 무에타이 · 킥복싱과 체급이 같아도 종목이 다르므로 필드를 따로 둔다 */
  muayThaiKickboxingNoFace?:
    | MuayThaiKickboxingNoFaceWeightClassPayload
    | undefined;
  /** 노기 주짓수 */
  noGiJiuJitsu?:
    | NoGiJiuJitsuWeightClassPayload
    | undefined;
  /** 이 체급이 적용되는 연령 부문 (부) */
  division: AgeDivisionPayload[];
  /** 체급 대상 성별 (성별을 나누지 않는 체급은 GENDER_ANY) */
  gender: GenderPayload;
  /**
   * 표시명 — 체급명 + 체중 범위 (예: "성인부 남자 웰터급(-65kg)")
   * 체급명에 이미 체중이 적힌 체급(초등부 -22kg) 과 무체급은 체급명 그대로다
   */
  name: string;
  /** 상한 체중 — 이하(inclusive). kg 소수점 문자열, 상한이 없으면 "" */
  maxWeightKg: string;
  /** 하한 체중 — 초과(exclusive). +체급에만 있다. 없으면 "" */
  minWeightKg: string;
  /** +체급 여부 (하한이 있는 체급. 예: 슈퍼헤비급 +90kg) */
  isOverLimit: boolean;
}

function createBaseWeightClassPayload(): WeightClassPayload {
  return {
    sport: 0,
    amateurBoxing: undefined,
    immafMma: undefined,
    muayThaiKickboxing: undefined,
    proMma: undefined,
    chickenFight: undefined,
    muayThaiKickboxingNoFace: undefined,
    noGiJiuJitsu: undefined,
    division: [],
    gender: 0,
    name: "",
    maxWeightKg: "",
    minWeightKg: "",
    isOverLimit: false,
  };
}

export const WeightClassPayload: MessageFns<WeightClassPayload> = {
  encode(message: WeightClassPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sport !== 0) {
      writer.uint32(8).int32(message.sport);
    }
    if (message.amateurBoxing !== undefined) {
      writer.uint32(16).int32(message.amateurBoxing);
    }
    if (message.immafMma !== undefined) {
      writer.uint32(24).int32(message.immafMma);
    }
    if (message.muayThaiKickboxing !== undefined) {
      writer.uint32(32).int32(message.muayThaiKickboxing);
    }
    if (message.proMma !== undefined) {
      writer.uint32(40).int32(message.proMma);
    }
    if (message.chickenFight !== undefined) {
      writer.uint32(48).int32(message.chickenFight);
    }
    if (message.muayThaiKickboxingNoFace !== undefined) {
      writer.uint32(104).int32(message.muayThaiKickboxingNoFace);
    }
    if (message.noGiJiuJitsu !== undefined) {
      writer.uint32(112).int32(message.noGiJiuJitsu);
    }
    writer.uint32(58).fork();
    for (const v of message.division) {
      writer.int32(v);
    }
    writer.join();
    if (message.gender !== 0) {
      writer.uint32(64).int32(message.gender);
    }
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    if (message.maxWeightKg !== "") {
      writer.uint32(82).string(message.maxWeightKg);
    }
    if (message.minWeightKg !== "") {
      writer.uint32(90).string(message.minWeightKg);
    }
    if (message.isOverLimit !== false) {
      writer.uint32(96).bool(message.isOverLimit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WeightClassPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeightClassPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.amateurBoxing = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.immafMma = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.muayThaiKickboxing = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.proMma = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.chickenFight = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.muayThaiKickboxingNoFace = reader.int32() as any;
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.noGiJiuJitsu = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag === 56) {
            message.division.push(reader.int32() as any);

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.division.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.maxWeightKg = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.minWeightKg = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isOverLimit = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WeightClassPayload {
    return {
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      amateurBoxing: isSet(object.amateurBoxing)
        ? amateurBoxingWeightClassPayloadFromJSON(object.amateurBoxing)
        : undefined,
      immafMma: isSet(object.immafMma) ? immafMmaWeightClassPayloadFromJSON(object.immafMma) : undefined,
      muayThaiKickboxing: isSet(object.muayThaiKickboxing)
        ? muayThaiKickboxingWeightClassPayloadFromJSON(object.muayThaiKickboxing)
        : undefined,
      proMma: isSet(object.proMma) ? proMmaWeightClassPayloadFromJSON(object.proMma) : undefined,
      chickenFight: isSet(object.chickenFight)
        ? chickenFightWeightClassPayloadFromJSON(object.chickenFight)
        : undefined,
      muayThaiKickboxingNoFace: isSet(object.muayThaiKickboxingNoFace)
        ? muayThaiKickboxingNoFaceWeightClassPayloadFromJSON(object.muayThaiKickboxingNoFace)
        : undefined,
      noGiJiuJitsu: isSet(object.noGiJiuJitsu)
        ? noGiJiuJitsuWeightClassPayloadFromJSON(object.noGiJiuJitsu)
        : undefined,
      division: globalThis.Array.isArray(object?.division)
        ? object.division.map((e: any) => ageDivisionPayloadFromJSON(e))
        : [],
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      maxWeightKg: isSet(object.maxWeightKg) ? globalThis.String(object.maxWeightKg) : "",
      minWeightKg: isSet(object.minWeightKg) ? globalThis.String(object.minWeightKg) : "",
      isOverLimit: isSet(object.isOverLimit) ? globalThis.Boolean(object.isOverLimit) : false,
    };
  },

  toJSON(message: WeightClassPayload): unknown {
    const obj: any = {};
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.amateurBoxing !== undefined) {
      obj.amateurBoxing = amateurBoxingWeightClassPayloadToJSON(message.amateurBoxing);
    }
    if (message.immafMma !== undefined) {
      obj.immafMma = immafMmaWeightClassPayloadToJSON(message.immafMma);
    }
    if (message.muayThaiKickboxing !== undefined) {
      obj.muayThaiKickboxing = muayThaiKickboxingWeightClassPayloadToJSON(message.muayThaiKickboxing);
    }
    if (message.proMma !== undefined) {
      obj.proMma = proMmaWeightClassPayloadToJSON(message.proMma);
    }
    if (message.chickenFight !== undefined) {
      obj.chickenFight = chickenFightWeightClassPayloadToJSON(message.chickenFight);
    }
    if (message.muayThaiKickboxingNoFace !== undefined) {
      obj.muayThaiKickboxingNoFace = muayThaiKickboxingNoFaceWeightClassPayloadToJSON(message.muayThaiKickboxingNoFace);
    }
    if (message.noGiJiuJitsu !== undefined) {
      obj.noGiJiuJitsu = noGiJiuJitsuWeightClassPayloadToJSON(message.noGiJiuJitsu);
    }
    if (message.division?.length) {
      obj.division = message.division.map((e) => ageDivisionPayloadToJSON(e));
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.maxWeightKg !== "") {
      obj.maxWeightKg = message.maxWeightKg;
    }
    if (message.minWeightKg !== "") {
      obj.minWeightKg = message.minWeightKg;
    }
    if (message.isOverLimit !== false) {
      obj.isOverLimit = message.isOverLimit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WeightClassPayload>, I>>(base?: I): WeightClassPayload {
    return WeightClassPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeightClassPayload>, I>>(object: I): WeightClassPayload {
    const message = createBaseWeightClassPayload();
    message.sport = object.sport ?? 0;
    message.amateurBoxing = object.amateurBoxing ?? undefined;
    message.immafMma = object.immafMma ?? undefined;
    message.muayThaiKickboxing = object.muayThaiKickboxing ?? undefined;
    message.proMma = object.proMma ?? undefined;
    message.chickenFight = object.chickenFight ?? undefined;
    message.muayThaiKickboxingNoFace = object.muayThaiKickboxingNoFace ?? undefined;
    message.noGiJiuJitsu = object.noGiJiuJitsu ?? undefined;
    message.division = object.division?.map((e) => e) || [];
    message.gender = object.gender ?? 0;
    message.name = object.name ?? "";
    message.maxWeightKg = object.maxWeightKg ?? "";
    message.minWeightKg = object.minWeightKg ?? "";
    message.isOverLimit = object.isOverLimit ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
